import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { SurveySchema, SurveyStatusSchema } from '../../entities/survey';
/**
 * List Surveys Request Schema
 * GET /api/v2/surveys
 * No `user` filter: the list is hard-scoped to the requester in the service.
 * `stepRecording` is an ObjectId schema because the service hands it straight
 * to `createFromHexString`, which throws a raw BSONError (500) on anything else.
 */ export const ListSurveysRequestSchema = z.object({
    stepRecording: ObjectIdSchema.optional(),
    status: SurveyStatusSchema.optional()
});
/**
 * List Surveys Response Schema
 * Returned on successful retrieval
 * Contains an array of surveys
 */ export const ListSurveysResponseSchema = z.object({
    surveys: z.array(SurveySchema)
});
/**
 * List Surveys Error Schema
 * Returned when retrieval fails
 */ export const ListSurveysErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-surveys.schema.js.map